import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from '@/patient-app-common/api/baseApi';
import authSlice from '@/patient-app-common/slices/authSlice';
import appSlice from '@/patient-app-common/slices/appSlice';

import webAppSlice from './webAppSlice';

const combinedReducers = combineReducers({
  app: appSlice,
  auth: authSlice,
  webApp: webAppSlice,
  [baseApi.reducerPath]: baseApi.reducer,
});

export const coreReducer = (
  state: ReturnType<typeof combinedReducers> | undefined,
  action: { type: string }
) => {
  if (action.type === 'auth/logout') {
    const { app } = state || {};
    state = { app } as ReturnType<typeof combinedReducers>;
  }

  return combinedReducers(state, action);
};

export type CoreReducerState = ReturnType<typeof coreReducer>;
